import FilterContainer from "../../../../../../component/general/filter/FilterContainer";
import FilterGroup from "../../../../../../component/general/filter/FilterGroup";
import FilterToggle from "../../../../../../component/general/filter/FilterToggle";

const SalesFilter = ({ onLayoutChange }) => {

    const onChange = (field) => (val) => {
        onLayoutChange(field, val);
    }

    return (
        <FilterContainer header="Filters">
            <FilterGroup name="Layout">
                <FilterToggle
                    options={["Grid", "List"]}
                    defaultOption={"Grid"}
                    onChange={onChange("Grid")}
                />
                {/*<FilterToggle*/}
                {/*    options={["Show Total", "Hide Total"]}*/}
                {/*    defaultOption={"Show Total"}*/}
                {/*    onChange={onChange("Total")}*/}
                {/*/>*/}
                <FilterToggle
                    options={["Uniform Scale", "Individual Scale"]}
                    defaultOption={"Uniform Scale"}
                    onChange={onChange("Scale")}
                />
            </FilterGroup>
        </FilterContainer>
    )
}

export default SalesFilter;
